import type {ReactElement} from 'react';
import React from 'react';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';

export function ItemColorFill(): ReactElement<any> | null {
  const type = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const color = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');

  if (!color || type === undefined) {
    return null;
  }

  return <BottomBarItemColorFill type={type} color={color} />;
}
